import gql from 'graphql-tag';
import { transientPersonLastAccessesResponseFragment } from '../local_attendance/fragment';
import {
  transientPersonManagementResponseFragment,
  transientPersonManagementWithDetailsFragment,
  transientPersonCondominiumOptionFragment,
} from './fragment';

export const getTransientPersons = gql`
  query transientPersons(
    $partnerPersonContextId: ID!
    $condominiumPersonContextId: ID!
    $filters: transientPersonManagementFiltersInput!
  ) {
    transientPersons(
      partnerPersonContextId: $partnerPersonContextId
      condominiumPersonContextId: $condominiumPersonContextId
      filters: $filters
    ) {
      ...transientPersonManagementResponseParts
    }
  }
  ${transientPersonManagementResponseFragment}
`;

export const getTransientPerson = gql`
  query transientPerson(
    $transientPersonId: ID!
    $condominiumPersonContextId: ID!
  ) {
    transientPerson(
      transientPersonId: $transientPersonId
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      ...transientPersonManagementWithDetailsParts
    }
  }
  ${transientPersonManagementWithDetailsFragment}
`;

export const getTransientPersonFacePhoto = gql`
  query transientPersonFacePhoto(
    $transientPersonId: ID!
    $condominiumPersonContextId: ID!
  ) {
    transientPersonFacePhoto(
      transientPersonId: $transientPersonId
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      id
      faceUrl
    }
  }
`;

export const getTransientPersonRecentAccesses = gql`
  query transientPersonRecentAccesses(
    $transientPersonId: ID!
    $page: Int!
    $pageSize: Int!
    $condominiumPersonContextId: ID!
  ) {
    transientPersonRecentAccesses(
      transientPersonId: $transientPersonId
      page: $page
      pageSize: $pageSize
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      ...transientPersonLastAccessesResponseParts
    }
  }
  ${transientPersonLastAccessesResponseFragment}
`;

export const getTransientPersonCondominiums = gql`
  query transientPersonCondominiums($partnerPersonContextId: ID!) {
    transientPersonCondominiums(
      partnerPersonContextId: $partnerPersonContextId
    ) {
      ...transientPersonCondominiumOptionParts
    }
  }
  ${transientPersonCondominiumOptionFragment}
`;
